<template>
   <div class="menu_dropdown actions_dropdown actions_dropdown-hover mar0">
    <ActionsMenu :caseDetails="caseDetails" @updatepetition="updatepetition"/>
    </div>              
</template>
  
  <script>
import ActionsMenu from './actionsMenu.vue';

  export default {
    inject: ["parentValidator"],
    created() {
        this.$validator = this.parentValidator;
    },
    components: {
        ActionsMenu
      },
   
    data() {
      return {
      
      };
    },
    methods: {
      updatepetition(){
      this.$emit("updatepetition", "Case Details");
    },
    },
    props:{
      caseDetails:null,
    }
  };
  </script>
  
  